import React, { memo, useState, useEffect } from 'react'
import { Card, CardBody, Row, Col, Progress } from 'reactstrap'
import {isUndefined, numberWithCommas} from '@common/utils'
import { Doughnut } from "react-chartjs-2"
import { HEALTHSCORECOLOR } from '@common/constants'

import { CDU_TYPE, AIR_TYPE } from '@common/constants'

import TreemapChart from '@components/TreemapChart'

const labelDonut = ['81%-100%', '61%-80%', '41%-60%', '21%-40%', '0%-20%']
const themeColors = [
    HEALTHSCORECOLOR.HEALTHY, HEALTHSCORECOLOR.RISK, HEALTHSCORECOLOR.HIGHRISK, HEALTHSCORECOLOR.UNHEALTHY, HEALTHSCORECOLOR.DANGER
]

const HistoricalPanelRight = ({
    parameterDetailByGroup,
    typeCatagoryName,
    averageData,
    healthScoreDonutList,
    alertDataTreemapList
}) => {
    const [isShowHealthScore, setIsShowHealthScore] = useState(false)
    const [isShowAvgTemp, setIsShowAvgTemp] = useState(false)
    const [isShowAvgStatus, setIsShowAvgStatus] = useState(false)
    const [isShowAvgPressure, setIsShowAvgPressure] = useState(false)
    const [isShowAvgCurrent, setIsShowAvgCurrent] = useState(false)
    const [isShowAvgVoltage, setIsShowAvgVoltage] = useState(false)
    const [isShowAvgPerformance, setIsShowAvgPerformance] = useState(false)
    const [isShowAvgSuperheat, setIsShowAvgSuperheat] = useState(false)
    const [isShowAlertData, setIsShowAlertData] = useState(false)
    const [isShowAvgRPS, setIsShowAvgRPS] = useState(false)
    const [isShowAvgPower, setIsShowAvgPower] = useState(false)
    const [isShowAvgEnergy, setIsShowAvgEnergy] = useState(false)

    const { avg_healthscore } = averageData

    useEffect(() => {
        onReset()
        if (averageData && parameterDetailByGroup) {
            if (!isUndefined(avg_healthscore)) {
                setIsShowHealthScore(true)
            }
            if (!isUndefined(parameterDetailByGroup.Temp) &&
                parameterDetailByGroup.Temp.length > 0) {
                setIsShowAvgTemp(true)
            }
            if (!isUndefined(parameterDetailByGroup.Status) &&
                parameterDetailByGroup.Status.length > 0
            ) {
                setIsShowAvgStatus(true)
            }
            if (!isUndefined(parameterDetailByGroup.Pressure) &&
                parameterDetailByGroup.Pressure.length > 0) {
                setIsShowAvgPressure(true)
            }
            if (!isUndefined(parameterDetailByGroup.Current) &&
                parameterDetailByGroup.Current.length > 0) {
                setIsShowAvgCurrent(true)
            }
            if (!isUndefined(parameterDetailByGroup.Voltage) &&
                parameterDetailByGroup.Voltage.length > 0) {
                setIsShowAvgVoltage(true)
            }
            if (!isUndefined(parameterDetailByGroup.Performance) &&
                parameterDetailByGroup.Performance.length > 0) {
                setIsShowAvgPerformance(true)
            }
            if (!isUndefined(parameterDetailByGroup.Superheat) &&
                parameterDetailByGroup.Superheat.length > 0) {
                setIsShowAvgSuperheat(true)
            }
            if (!isUndefined(parameterDetailByGroup.RPS) &&
                parameterDetailByGroup.RPS.length > 0) {
                setIsShowAvgRPS(true)
            }
            if (!isUndefined(parameterDetailByGroup.Power) &&
                parameterDetailByGroup.Power.length > 0) {
                setIsShowAvgPower(true)
            }
            if (!isUndefined(parameterDetailByGroup.Energy) &&
                parameterDetailByGroup.Energy.length > 0) {
                setIsShowAvgEnergy(true)
            }
        }

    }, [averageData])

    useEffect(() => {
        if (healthScoreDonutList && !isShowHealthScore) {
            let isDataInDonutList = false
            healthScoreDonutList.forEach(item => {
                if (item !== 0) {
                    isDataInDonutList = true
                }
            })
            setIsShowHealthScore(isDataInDonutList)
        }
    }, [healthScoreDonutList])

    useEffect(() => {
        if (alertDataTreemapList && alertDataTreemapList.countAlert > 0) {
            setIsShowAlertData(true)
        }
    }, [alertDataTreemapList])

    const onReset = () => {
        setIsShowHealthScore(false)
        setIsShowAvgTemp(false)
        setIsShowAvgStatus(false)
        setIsShowAvgPressure(false)
        setIsShowAvgCurrent(false)
        setIsShowAvgPerformance(false)
        setIsShowAvgSuperheat(false)
        setIsShowAlertData(false)
        setIsShowAvgRPS(false)
        setIsShowAvgPower(false)
        setIsShowAvgEnergy(false)
    }

    const HealthScoreDonutChart = () => {
        return (
            <Doughnut
                data={{
                    labels: labelDonut,
                    datasets: [
                        {
                            label: "Health Score",
                            data: healthScoreDonutList,
                            backgroundColor: themeColors
                        }
                    ]
                }}
                options={{
                    maintainAspectRatio: false,
                    responsive: false,
                    legend: {
                        align: 'center',
                        position: 'right'
                    }
                }}
                height={200}
                redraw
            />
        )
    }

    const HealthScoreStatus = ({ value }) => {
        let healthscoreStatus = ""
        let healthscoreColor = ""
        if (Number(value) > 80 && Number(value) <= 100) {
            healthscoreStatus = "Good"
            healthscoreColor = HEALTHSCORECOLOR.HEALTHY
        } else if (Number(value) > 60 && Number(value) <= 80) {
            healthscoreStatus = "Fair"
            healthscoreColor = HEALTHSCORECOLOR.RISK
        } else if (Number(value) > 40 && Number(value) <= 60) {
            healthscoreStatus = "Risk"
            healthscoreColor = HEALTHSCORECOLOR.HIGHRISK
        } else if (Number(value) > 20 && Number(value) <= 40) {
            healthscoreStatus = "Poor"
            healthscoreColor = HEALTHSCORECOLOR.UNHEALTHY
        } else if (Number(value) >= 0 && Number(value) <= 20) {
            healthscoreStatus = "Very Poor"
            healthscoreColor = HEALTHSCORECOLOR.DANGER
        }

        return (
            <div className='healthscore-status'>
                <div className="healthscore-text" style={{ color: healthscoreColor }}>
                    {healthscoreStatus} : {value + '%'}
                </div>
                <Progress barStyle={{ backgroundColor: healthscoreColor }} value={value} />
            </div>
        )
    }

    const TextDisplay = ({ text, value, colorStyle }) => (
        <Row className='text-display'>
            <Col lg='8'>{text}</Col>
            <Col lg='4'>
                <div>
                    <span className="text-value" style={{ color: colorStyle }}>
                        {numberWithCommas(value)}
                    </span>
                </div>
            </Col>
        </Row>
    )

    const ProgressBarDisplay = ({ text, value, colorStyle }) => (
        <div className='status-display'>
            {text} {' : '}
            <span style={{ color: colorStyle, fontWeight: 'bold' }}>
                {value !== ' -' ? (
                    value + ' %'
                ) : value}
            </span>
            <Progress barStyle={{ backgroundColor: colorStyle }} value={value} />
        </div>
    )

    const renderHealthScore = () => {
        return (
            <Card className="mb-1">
                <CardBody>
                    <HealthScoreDonutChart />
                    <hr />
                    <h5 className='text-left'>AVG Health Score</h5>
                    {!isUndefined(avg_healthscore) &&
                        <HealthScoreStatus value={Math.round(avg_healthscore)} />
                    }
                </CardBody>
            </Card>
        )
    }

    const renderAvgTemp = () => {
        const tempParamEl = []
        const tempParameterDetail = parameterDetailByGroup.Temp
        tempParameterDetail.forEach((item) => {
            return (
                tempParamEl.push(
                    <TextDisplay
                        key={item.id}
                        text={item.description}
                        value={averageData[`avg_${item.parameterName}`] || ' -'}
                        colorStyle={item.color}
                    />
                )
            )
        })

        return (
            <Card className="mb-1">
                <CardBody>
                    <h5 className='text-center'>
                        {`AVG ${tempParameterDetail[0].unitGroup} (${tempParameterDetail[0].unit})`}
                    </h5>
                    <hr />
                    {tempParamEl}
                </CardBody>
            </Card>
        )
    }

    const renderAvgRPS = () => {
        const tempParamEl = []
        const tempParameterDetail = parameterDetailByGroup.RPS
        tempParameterDetail.forEach((item) => {
            return (
                tempParamEl.push(
                    <TextDisplay
                        key={item.id}
                        text={item.description}
                        value={averageData[`avg_${item.parameterName}`] || ' -'}
                        colorStyle={item.color}
                    />
                )
            )
        })

        return (
            <Card className="mb-1">
                <CardBody>
                    <h5 className='text-center'>
                        {`AVG ${tempParameterDetail[0].unitGroup} (${tempParameterDetail[0].unit})`}
                    </h5>
                    <hr />
                    {tempParamEl}
                </CardBody>
            </Card>
        )
    }
  const renderAvgPower = () => {
    const tempParamEl = []
    const tempParameterDetail = parameterDetailByGroup.Power
    tempParameterDetail.forEach((item) => {
      return (
        tempParamEl.push(
          <TextDisplay
            key={item.id}
            text={item.description}
            value={averageData[`avg_${item.parameterName}`] || ' -'}
            colorStyle={item.color}
          />
        )
      )
    })

    return (
      <Card className="mb-1">
        <CardBody>
          <h5 className='text-center'>
            {`AVG ${tempParameterDetail[0].unitGroup} (${tempParameterDetail[0].unit})`}
          </h5>
          <hr />
          {tempParamEl}
        </CardBody>
      </Card>
    )
  }

    const renderAvgEnergy = () => {
        const tempParamEl = []
      const tempParameterDetail = parameterDetailByGroup.Energy
      tempParameterDetail.forEach((item) => {
        return (
          tempParamEl.push(
            <TextDisplay
              key={item.id}
              text={item.description}
              value={averageData[`${item.parameterName}`] || ' -'}
              colorStyle={item.color}
            />
          )
        )
      })

        return (
            <Card className="mb-1">
                <CardBody>
                    <h5 className='text-center'>
                      {`${tempParameterDetail[0].unitGroup} (${tempParameterDetail[0].unit})`}
                    </h5>
                    <hr />
                    {tempParamEl}
                </CardBody>
            </Card>
        )
    }

    const renderAvgStatus = () => {
        const statusParamEl = []
        const statusParameterDetail = parameterDetailByGroup.Status
        statusParameterDetail.forEach((item) => {
            return (
                statusParamEl.push(
                    <ProgressBarDisplay
                        key={item.id}
                        text={item.description}
                        value={Math.round(averageData[`avg_${item.parameterName}`] * 100) || ' -'}
                        colorStyle={item.color}
                    />
                )
            )
        })

        return (
            <Card className="mb-1">
                <CardBody>
                    <h5 className='text-center'>
                        {`AVG ${statusParameterDetail[0].unitGroup}`}
                    </h5>
                    <hr />
                    {statusParamEl}
                </CardBody>
            </Card>
        )
    }

    const renderAvgPressure = () => {
        const pressureParamEl = []
        const pressureParameterDetail = parameterDetailByGroup.Pressure
        pressureParameterDetail.forEach((item) => {
            return (
                pressureParamEl.push(
                    <TextDisplay
                        key={item.id}
                        text={item.description}
                        value={averageData[`avg_${item.parameterName}`] || ' -'}
                        colorStyle={item.color}
                    />
                )
            )
        })

        return (
            <Card className="mb-1">
                <CardBody>
                    <h5 className='text-center'>
                        {`AVG ${pressureParameterDetail[0].unitGroup} (${pressureParameterDetail[0].unit})`}
                    </h5>
                    <hr />
                    {pressureParamEl}
                </CardBody>
            </Card>
        )
    }

    const renderAvgCurrent = () => {
        const currentParamEl = []
        const currentParameterDetail = parameterDetailByGroup.Current
        currentParameterDetail.forEach((item) => {
            return (
                currentParamEl.push(
                    <TextDisplay
                        key={item.id}
                        text={item.description}
                        value={averageData[`avg_${item.parameterName}`] || ' -'}
                        colorStyle={item.color}
                    />
                )
            )
        })

        return (
            <Card className="mb-1">
                <CardBody>
                    <h5 className='text-center'>
                        {`AVG ${currentParameterDetail[0].unitGroup} (${currentParameterDetail[0].unit})`}
                    </h5>
                    <hr />
                    {currentParamEl}
                </CardBody>
            </Card>
        )
    }

    const renderAvgVoltage = () => {
        const currentParamEl = []
        const currentParameterDetail = parameterDetailByGroup.Voltage
        currentParameterDetail.forEach((item) => {
            return (
                currentParamEl.push(
                    <TextDisplay
                        key={item.id}
                        text={item.description}
                        value={averageData[`avg_${item.parameterName}`] || ' -'}
                        colorStyle={item.color}
                    />
                )
            )
        })

        return (
            <Card className="mb-1">
                <CardBody>
                    <h5 className='text-center'>
                        {`AVG ${currentParameterDetail[0].unitGroup} (${currentParameterDetail[0].unit})`}
                    </h5>
                    <hr />
                    {currentParamEl}
                </CardBody>
            </Card>
        )
    }

    const renderAvgPerformance = () => {
        const performanceParamEl = []
        const performanceParameterDetail = parameterDetailByGroup.Performance
        performanceParameterDetail.forEach((item) => {
            return (
                performanceParamEl.push(
                    <TextDisplay
                        key={item.id}
                        text={item.description}
                        value={averageData[`avg_${item.parameterName}`] || ' -'}
                        colorStyle={item.color}
                    />
                )
            )
        })

        return (
            <Card className="mb-1">
                <CardBody>
                    <h5 className='text-center'>
                        {`AVG ${performanceParameterDetail[0].unitGroup} (${performanceParameterDetail[0].unit})`}
                    </h5>
                    <hr />
                    {performanceParamEl}
                </CardBody>
            </Card>
        )
    }

    const renderAvgSuperheat = () => {
        const SuperheatParamEl = []
        const SuperheatParameterDetail = parameterDetailByGroup.Superheat
        SuperheatParameterDetail.forEach((item) => {
            return (
                SuperheatParamEl.push(
                    <TextDisplay
                        key={item.id}
                        text={item.description}
                        value={averageData[`avg_${item.parameterName}`] || ' -'}
                        colorStyle={item.color}
                    />
                )
            )
        })

        return (
            <Card className="mb-1">
                <CardBody>
                    <h5 className='text-center'>
                        {`AVG ${SuperheatParameterDetail[0].unitGroup}`}
                    </h5>
                    <hr />
                    {SuperheatParamEl}
                </CardBody>
            </Card>
        )
    }

    const renderAlertData = () => {
        return (
            <Card className="mb-1">
                <CardBody>
                    <TreemapChart
                        title={alertDataTreemapList.name}
                        data={alertDataTreemapList.result}
                    />
                </CardBody>
            </Card>
        )
    }

    return (
        <>
            {isShowHealthScore && typeCatagoryName !== AIR_TYPE
                && renderHealthScore()}
            {isShowAvgTemp && renderAvgTemp()}
            {isShowAvgStatus && renderAvgStatus()}
            {isShowAvgPressure && typeCatagoryName === CDU_TYPE
                && renderAvgPressure()}
            {isShowAvgCurrent && renderAvgCurrent()}
            {isShowAvgVoltage && renderAvgVoltage()}
            {isShowAvgPerformance && renderAvgPerformance()}
            {isShowAvgSuperheat && renderAvgSuperheat()}
            {isShowAvgPower && renderAvgPower()}
            {isShowAvgEnergy && renderAvgEnergy()}
            {isShowAlertData && renderAlertData()}
            {isShowAvgRPS && renderAvgRPS()}
        </>
    )
}


export default memo(HistoricalPanelRight)
